import { BlockSessionContent } from 'store/states/lessons.state'
import { BlockTypes } from 'enum'
import api from '../..'

const mapSessionItem = (item: Record<string, unknown>) => ({
  name: String(item.name || ''),
  description: String(item.description || ''),
  startDate: String(item.startDate || item.start_date || ''),
  startTime: String(item.startTime || item.start_time || ''),
  meetingUrl: String(item.meetingUrl || item.meeting_url || ''),
  duration: Number(item.duration ?? 0),
  position: Number(item.position ?? 0),
  status:
    (item.status as BlockSessionContent['sessions'][number]['status']) ||
    'upcoming',
  canJoin: Boolean(item.canJoin ?? item.can_join ?? false),
  joinedAt: (item.joinedAt || item.joined_at || null) as string | null,
})

export const getSessionBlock = (blockId: number) => {
  return api.get(`block_session/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }): BlockSessionContent => {
      const { id, name, description, timezone, sessions, blockInstanceable } =
        attributes

      return {
        id,
        name,
        description,
        timezone,
        sessions: (sessions || []).map(mapSessionItem),
        mandatory: Boolean(blockInstanceable?.mandatory),
        blockInstanceable,
        type: BlockTypes.BlockSession,
      }
    }
  )
}
